import { useEffectOnce } from 'react-use';
import {
  resetErrorToastDismissMode,
  setErrorToastDismissMode,
} from '../utils/toast';

export const useManuallyDismissedErrorToasts = () => {
  useEffectOnce(() => {
    setErrorToastDismissMode('manual');
    return () => {
      resetErrorToastDismissMode();
    };
  });
};
